import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IRemoteRefreshSchedule } from '../../../ts/ServerApi/types/IRemoteRefreshSchedule';

export interface IDeleteRemoteRefreshSchedulesParams {
  targetId: string;
  schedules: IRemoteRefreshSchedule[];
}

export class DeleteRemoteRefreshSchedulesRequest extends Request<IDeleteRemoteRefreshSchedulesParams, IResult> {
  constructor(params: IDeleteRemoteRefreshSchedulesParams) {
    super('deleteRemoteRefreshSchedules', params);
  }
}
